import React, { useState, useRef, useCallback } from 'react';
import styles from './Photo.module.scss';
import cameraIcon from '../assets/camera.gif';
import Webcam from 'react-webcam';

const videoConstraints = {
  facingMode: 'user',
};

function Photo() {
  const [imgSrc, setImgSrc] = useState(null);
  const webcamRef = useRef(null);

  function takePhoto() {
    const imageSrc = webcamRef.current.getScreenshot();
    setImgSrc(imageSrc);
    console.log(imageSrc);
  }

  return (
    <div className={styles.container}>
      <div className={styles.inner}>
        {
          !imgSrc ? (
            <>
              <div className={styles.cameraWrapper}>
                <Webcam
                  audio={false}
                  ref={webcamRef}
                  screenshotFormat='image/jpeg'
                  videoConstraints={videoConstraints}
                />
              </div>

              <div className={styles.cameraButtonWrapper} onClick={takePhoto}>
                <img className={styles.cameraButton} src={cameraIcon} alt='cameraIcon' />
              </div>
            </>
          ) : (
            // {imgSrc && (
            //   <>
            <div className={styles.photoWrapper}>
              <div className={styles.photo}>
                <img src={imgSrc} />
              </div>
              <div className={styles.photoComent}>서현이의 생일을 축하하며</div>
            </div>
          )
          //   </>
          // )}
        }
      </div>
    </div>
  );
}

export default Photo;
